import React, { useState } from 'react';
import { Modal, Box, Typography, IconButton, Button, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// import TemplateForm from '../TemplateForm';s
import UpdateEvent from './UpdateEvent';

const style = {
  position: 'absolute',
  top: '50px',
  left: '50%',
  transform: 'translateX( -50%)',
  width: 600,
  height: 'max-content',
  maxHeight: '95vh',
  maxWidth: '90vw',
  overflowY: 'scroll',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '12px',
};

const UpdateEventModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const handleSubmitModal = (event) => {
    setIsOpen(false);
    // handleEventList();
  };

  return (
    <Stack>
      <Button
        variant="secondary"
        component="label"
        // sx={{ mt: 2 }}
        onClick={() => setIsOpen(true)}
        sx={{ background: '#E0E4E8 !important' }}
        // disabled={selectedTemplate === null || isButtonDisabled}
      >
        Update Event
        {/* The input is embedded in the label so the button click will trigger it without the need for a click handler */}
      </Button>
      <Modal open={isOpen} onClose={handleCloseModal} aria-labelledby="modal-modal-title">
        <Box sx={style}>
          <Stack direction="row" justifyContent="space-between" mb={4}>
            <Typography variant="h6">Update Event</Typography>
            <IconButton
              aria-label="close"
              onClick={handleCloseModal}
              sx={{
                // position: 'absolute',
                // right: 8,
                // top: 8,
                width: '20px',
                height: '20px',
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>

          <UpdateEvent onClose={handleSubmitModal} />
        </Box>
      </Modal>
    </Stack>
  );
};

export default UpdateEventModal;
